import { HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { Row, Col } from 'antd';
import TranslateToggler from 'components/TranslateToggler';
import { useTranslateReport } from 'hooks/useTranslateReport';

const CancelDetail = styled.div`
  border-bottom: none;
  > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    margin-bottom: 4px;
    color: #515359;
    height: 24px;
  }
  .ant-col {
    width: 100%;
  }
  .ant-btn {
    font-size: 12px;
  }
`;

const SectionCancel = styled.section`
  display: block;
  padding: 6px 12px;
  font-size: 12px;
  color: #84868c;
  background: #f7f9fa;
  border-radius: 2px;
`;

export interface TradeCancelInfoProps extends HTMLAttributes<HTMLElement> {
  trade: Conversation.Trade.Vo;
}

function TradeBuyerMemos(props: TradeCancelInfoProps) {
  const { trade, ...otherProps } = props;

  const { buyerMemos, buyerMemosTrans, internalTradeId } = trade;
  const { t } = useTranslate();
  const translateReport = useTranslateReport();

  if (!buyerMemos) {
    return null;
  }

  return (
    <CancelDetail {...otherProps}>
      <div>{t('trade.买家备注')}</div>
      <Row justify="space-between">
        <Col>
          <SectionCancel>
            <TranslateToggler
              text={buyerMemos}
              defaultMap={buyerMemosTrans}
              showTrans
              reporter={(_t, _l, map) => {
                translateReport(
                  {
                    table: 'TRADE',
                    field: 'BUYER_MEMOS',
                    key: internalTradeId,
                    originText: buyerMemos,
                    translation: map,
                  },
                  'Common',
                );
              }}
            />
          </SectionCancel>
        </Col>
      </Row>
    </CancelDetail>
  );
}

export default TradeBuyerMemos;
